import React from 'react'
import { Navigate } from 'react-router-dom'
import { PrivateLayout } from '@/components/Layouts'
import { PanelProvider } from '@/features/panel/components'
import { PanelSwitch, RouteGuard } from '@/routes'
import { getGeneralRoutes } from './routes'

const mapChildrenRoutes = (routes: Array<any>, user: object | null) => [
  ...routes.map(({ path, index, element, roles, guards }, i) => {
    return {
      key: `${i}-${path}`,
      path,
      index,
      element: (
        <RouteGuard roles={roles} guards={guards} user={user}>
          {element}
        </RouteGuard>
      ),
    }
  }),
]

export const getPrivateRoutes = (isLoggedIn: boolean, user: object | null) => {
  return [
    {
      path: '/*',
      element: isLoggedIn ? <PrivateLayout /> : <Navigate to={`/`} replace />,
      children: [
        {
          index: isLoggedIn,
          element: <PanelSwitch user={user} />,
        },
        {
          element: <PanelProvider />,
          children: [...mapChildrenRoutes(getGeneralRoutes(), user)],
        },
        {
          path: '*',
          element: <Navigate to={`/`} replace />,
        },
      ],
    },
  ]
}
